<template>
  <div class="merchant">
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="isMobile">
      Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <div v-if="column.field === 'created_at'">
          {{ formatDate(entry[column.field]) }}
        </div>
        <div v-else-if="column.field === 'survey_schedule_at'">
          {{ formatDate(entry[column.field], true) }}
        </div>
        <div
          v-else-if="
            column.field === 'fleet_types' || column.field === 'logistic_fields'
          "
        >
          {{ entry[column.field].join(", ") }}
        </div>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">
      Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}
    </div>
    <div
      class="mt-8 flex justify-center items-center mb-6"
      v-if="filteredData && filteredData.length > 0"
    >
      <pagination
        :currentPage="currentPage"
        :totalCount="totalRecords"
        :pageSize="pageSize"
        @onPageChange="onPageChange"
      />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import dayjs from "dayjs"
var utc = require("dayjs/plugin/utc")
dayjs.extend(utc)

export default {
  components: {
    TableComponent: () =>
      import(/* webpackChunkName: "Table" */ "@/components/Table/Table"),
    Pagination: () =>
      import(
        /* webpackChunkName: "Pagination" */ "@/components/Pagination/Pagination"
      )
  },
  data() {
    return {
      searchTerm: "",
      isModalVisible: false,
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true,
      columns: [
        { label: "Nama Perusahaan", field: "company_name" },
        { label: "Nama Mitra Logistik", field: "logistic_name" },
        { label: "Bidang Usaha", field: "logistic_fields" },
        { label: "No. Handphone", field: "phone_number" },
        { label: "Email", field: "email" },
        { label: "Alamat", field: "address" },
        { label: "Jenis Armada", field: "fleet_types" },
        { label: "Jumlah Armada", field: "total_fleet" },
        { label: "Tanggal Daftar", field: "created_at" },
        { label: "Jadwal Meeting", field: "survey_schedule_at" }
      ]
    }
  },
  computed: {
    ...mapGetters("common", ["isMobile"]),
    ...mapGetters("partner", ["selfRegistration"]),
    filteredData() {
      let temp = this.selfRegistration || []
      if (temp.length) {
        temp = temp.filter((item) => {
          return item.code !== ""
        })
      }
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({
        path: "/partner-self-registration",
        query: { page: 1 }
      })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getListPartner()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getListPartner()
      } else {
        this.$router.push({
          path: "/partner-self-registration",
          query: { page: 1 }
        })
        this.page = 1
        this.currentPage = 1
      }
    }
  },
  methods: {
    ...mapActions("partner", ["getSelfRegistration", "resendVerification"]),
    ...mapActions("common", ["showLoading", "hideLoading", "setToast"]),
    doResend(registerId) {
      this.showLoading()
      this.resendVerification({
        registerId: registerId
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: {
            type: "success",
            duration: 2000,
            primaryText: "Request Kirim Ulang Verifikasi Berhasil Diproses",
            secondaryText: "",
            callback: () => {}
          }
        })
      })
    },
    getListPartner() {
      this.showLoading()
      this.getSelfRegistration({
        params: {
          sort: "DESC",
          page: this.currentPage,
          per_page: this.pageSize
        }
      })
        .then((res) => {
          this.hideLoading()
          this.totalRecords = res.data.meta.total_item
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({
        path: "/partner-self-registration",
        query: { page: page }
      })
    },
    formatDate(value, time = false) {
      return time
        ? dayjs(value).utc().format("DD MMM YYYY, HH:mm")
        : dayjs(value).utc().format("DD MMM YYYY")
    }
  }
}
</script>
